export class ReviewOrderDto {
  id: number;
  approved: boolean;
  reprovedMsg: string;
}